import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=43b3a3a6&scoped=true"
var script = {}
import style0 from "./Notify.vue?vue&type=style&index=0&id=43b3a3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3a3a6",
  null
  
)

export default component.exports